import { render, staticRenderFns } from "./TransactionTypesProjectComponent.vue?vue&type=template&id=8509bb78"
import script from "./TransactionTypesProjectComponent.js?vue&type=script&lang=js&external"
export * from "./TransactionTypesProjectComponent.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports